import { DEPARTMENT_NAME_BY_CODE } from './enums/departments.js'

export interface Department {
  code: string
  name: string
  label: string
  shortLabel: string
}

const SHORT_DEPARTMENT_NAMES: Record<string, string> = {
  '04': 'Alpes-de-H.-P.',
  '06': 'Alpes-Mar.',
  '13': 'Bouches-du-Rh.',
  '17': 'Charente-Mar.',
  '31': 'Hte-Garonne',
  '35': 'Ille-et-V.',
  '37': 'Indre-et-L.',
  '43': 'Hte-Loire',
  '44': 'Loire-Atl.',
  '47': 'Lot-et-G.',
  '49': 'Maine-et-L.',
  '52': 'Hte-Marne',
  '54': 'Meurthe-et-M.',
  '64': 'Pyrénées-Atl.',
  '65': 'Hautes-Pyr.',
  '66': 'Pyrénées-Or.',
  '70': 'Hte-Saône',
  '71': 'Saône-et-L.',
  '74': 'Hte-Savoie',
  '76': 'Seine-Mar.',
  '77': 'Seine-et-M.',
  '82': 'Tarn-et-G.',
  '87': 'Hte-Vienne',
  '90': 'T. de Belfort',
  '92': 'Hauts-de-S.',
  '93': 'Seine-St-Denis',
}

export function departmentOf(code: string): Department | null {
  const name = DEPARTMENT_NAME_BY_CODE[code]
  if (name === undefined) return null
  const shortName = SHORT_DEPARTMENT_NAMES[code] ?? name
  return { code, name, label: `${code} - ${name}`, shortLabel: `${code} - ${shortName}` }
}
